import * as React from "react";

export const ContentSectionAlt = (
  props: React.HTMLAttributes<HTMLElement> & { children?: React.ReactNode }
): JSX.Element => {
  const { children, className, ...rest } = props;
  const base = "px-[15%] py-[50px] bg-[#f7f7f9] dark:bg-slate-900";
  const combined = className ? `${base} ${className}` : base;

  return (
    <section className={combined} {...rest}>
      {children}
    </section>
  );
};
